import VideoStreamOverlay from "./VideoStreamOverlay";

export default VideoStreamOverlay;